export default __webpack_public_path__ + "static/4-373a9082e877507c0f897c821a2b12ac.jpeg";